import React, { Component } from "react";
import Table from "../../../../components/UI/Table/Table";
import moment from "moment";


class CaseCountTableView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            sorted: {
                id: "dueDate",
                desc: true,
            },
            body: null,
            dataAutomationData: {},
            pageSize: 10,
            currentPageIndex: 0,
        };
    }

    tableColumns = [
        {
            Header: "Agg Start Date",
            id: "agreementStartDate",
            accessor: p => (moment(p.agreementStartDate).format("DD-MMM-YYYY"))
        },
        {
            Header: "Agg End Date",
            id: "agreementEndDate",
            accessor: p => (moment(p.agreementEndDate).format("DD-MMM-YYYY"))
        },
        {
            Header: "Volume Sharing Code",
            id: "volumeSharingCode",
            accessor: "volumeSharingCode"
        },
        {
            Header: "Case Count",
            id: "caseCount",
            accessor: "caseCount"
        },
        {
            Header: "Created At",
            id: "createdAt",
            accessor: p => (moment(p.createdAt).format("DD-MMM-YYYY"))
        },
        {
            Header: "Updated At",
            id: "updatedAt",
            accessor: p => (p.updatedAt == null ? "" : moment(p.updatedAt).format("DD-MMM-YYYY"))
        }
    ]

    componentDidUpdate(prevProps) {

    }

    render() {
        return (
            <Table
                data={this.props.data ? this.props.data.corporateCaseCountList : ""}
                columns={this.tableColumns}
                noDataText="No case count data found"
                multiSort={false}
                pages={this.props.data ? this.props.data.numberOfPages : 0}
                defaultPageSize={10}
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                onPageChange={pageIndex => {
                    // Called when the page index is changed by the user
                    this.setState({
                        currentPageIndex: pageIndex,
                    });
                    this.props.prepareTableDataRequest('', this.props.activeTab, pageIndex, this.state.pageSize)
                }}
                onPageSizeChange={(pageSize, pageIndex) => {
                    this.setState({
                        pageSize: pageSize,
                    });
                    this.props.prepareTableDataRequest('', this.props.activeTab, 0, this.state.pageSize)
                }}
            />
        )
    };
}

export default CaseCountTableView;